/**
 * Stickytable headers for confluence
 *
 * Adds stalking headers for viewpage and editor dependeds on a modified version of stalky headers
 * that allow extra options to be passed
 */

// eslint-disable-next-line no-restricted-imports
import $ from 'jquery';
import { isDarkFeatureEnabled } from '../utils/dark-features-query-selector';
import { bind } from '@confluence-classic/confluence-event_DO_NOT_USE';
require('./vendor/jquery.stickytableheaders');
import StickyViewpage from './inc/viewpage';
import StickyEditor from './inc/editor';

export default function stickyTableHeaders() {
	if (!isDarkFeatureEnabled('confluence-table-enhancements.sticky-headers.disabled')) {
		// auto initialize for the viewpage
		$(document).ready(StickyViewpage.initialize);
	}

	if (isDarkFeatureEnabled('confluence-table-enhancements.sticky-headers-editor')) {
		// auto initialize for the editor
		bind('rte-ready', StickyEditor.initialize);

		// this is to make stickyheaders works with quick-edit
		bind('rte-quick-edit-push-state', StickyEditor.initialize);
		bind('rte-quick-edit-push-hash', StickyEditor.initialize);
	}
}
